(function () {
    angular
        .module('advancedapp')
        .component('searchResults', {
            restrict: 'E',
            bindings: {
                results: '<',
                some: '@',
                gridView: '<',
                showmore: '@',
                limit: '<'
            },
            template: require('./search-results.html'),
            controller: controller,
            controllerAs: 'vm'
        });

    controller.$inject = ['$log', '$scope'];

    function controller($log, $scope) {

        var vm = this;
        var limit = 40;
        vm.$onInit = function () {

        }

        vm.$onChanges = function (changesObj) {


            if (changesObj.results && changesObj.results.currentValue) {

                vm.results = changesObj.results.currentValue;
            }

            if (changesObj.gridView && changesObj.gridView.currentValue) {

                vm.gridView = changesObj.gridView.currentValue;
            }

            addSupportForStyleObjectFit();
        }

        function addSupportForStyleObjectFit() {

            // Provide objectFit fallback for IE and Edge.
            // See: https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit 
            // See: https://codepen.io/pawelgrzybek/pen/Rrybqg

            if ('objectFit' in document.documentElement.style === true)
                return;

            var container = document.getElementsByClassName('grid-item');
            for (var i = 0; i < container.length; i++) {
                var image = container[i].querySelector('img');
                image.style.display = 'none';
                image.parentNode.style.backgroundSize = 'cover';
                image.parentNode.style.backgroundImage = 'url(' + image.src + ')';
                image.parentNode.style.backgroundPosition = 'center center';
            }
        }

        vm.showmoreResult = function () {
            vm.limit = vm.limit + 20;
        }

    }
})();